import t from "styled-components";
import e from "../../../utils/colors.js";
import o from "../../Text/index.js";
const s = t(o.Heading.H3)`
  display: flex;
  flex: 1;
  margin: 16px 0 !important; // Important? Yes.. Sitecore has a higher specificity css file that is overriding this
  font-weight: bold;
  color: ${e.blueGrey};
  justify-content: center;
`;
export {
  s as Content
};
